import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminAccessService {

  private httpOptions = {
    withCredentials: true,
    observe: 'response' as 'response',
    headers: new HttpHeaders()
  };

  constructor(private http: HttpClient) { }

  /**
   * Checks if the user has admin access by calling HEAD <basepath>/api/admin/access.
   * Returns true if 200 OK, and false if any error (e.g. 403 Forbidden).
   */
  public async checkAdminAccess(): Promise<boolean> {
    try {
      await this.http.head(`${environment.basePath}/admin/access`, this.httpOptions).toPromise();
      return true;
    } catch (error) {
      return false;
    }
  }
}
